module.exports = __webpack_public_path__ + "img/default.90c14a44.png";